'use strict';
var injectDynamicUtils = require('./components/injectDynamicUtils');

module.exports = {
    openTradeWizardModal: function () {
        $(document).on('click', '.trade-modal-link', function () {
            injectDynamicUtils.injectDynamicCSS('#trade-in-wizard');
            let url = $(this).attr('data-url');
            let $tradeModalLink = $('.trade-modal-link');
            if (!$('#trade-wizard-modal').length) {
                $tradeModalLink.addClass('link-disabled');
                $.ajax({
                    url: url,
                    method: 'get',
                    data: { format: 'ajax' }
                }).done(function (data) {
                    $('body').append(data);
                    injectDynamicUtils.injectDynamicJs('#trade-details-redesign');
                    $('#trade-wizard-modal').modal('show');
                    $tradeModalLink.removeClass('link-disabled');
                })
                .fail(function () {
                    $tradeModalLink.removeClass('link-disabled');
                });
            }
        });
        $(document).on('hidden.bs.modal', '#trade-wizard-modal', function () {
            $('.trade-wizard-modal').remove();
        });
    }
};
